import { HrOrgPosCardsRouterConstants } from '../constant/hr-org-pos-cards-router-constants';

export interface HrCardRouteConfig {
    showBack: boolean,
    cardsRoute: string,
    masterDataListRoute: string
}

export const HR_CORE_ORG_ROUTE_CONFIG: HrCardRouteConfig = {
    showBack: true,
    cardsRoute: HrOrgPosCardsRouterConstants.ORG_CARDS_MAIN,
    masterDataListRoute: HrOrgPosCardsRouterConstants.ORG_LIST,
}

export const HR_CORE_POS_ROUTE_CONFIG:HrCardRouteConfig = {
    showBack: true,
    cardsRoute: HrOrgPosCardsRouterConstants.POS_CARDS_MAIN,
    masterDataListRoute: HrOrgPosCardsRouterConstants.POS_LIST,
}
